export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-900"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20golden%20and%20deep%20red%20lighting%20accents%2C%20abstract%20film%20reel%20texture%20and%20projector%20beam%20effects%2C%20luxurious%20movie%20theater%20ambiance%20with%20velvet%20curtains%20and%20soft%20glow%2C%20dramatic%20lighting%20with%20film%20grain%20texture%2C%20rich%20dark%20tones%20with%20warm%20highlights%2C%20cinematic%20widescreen%20composition%2C%20high-end%20visual%20aesthetic&width=1600&height=900&seq=hero-bg-51movie&orientation=landscape"
          alt="51影视 - 沉浸式观影体验"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-500/20 text-primary-300 rounded-full border border-primary-500/30 mb-5">
              每日更新 · 海量片库
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-white leading-tight mb-4">
              51影视 · <span className="text-primary-400">免费影视在线观看</span>
            </h1>

            <p className="text-lg md:text-xl text-white/70 font-heading mb-6">
              高清不卡顿，不缓冲流畅体验
            </p>

            <div className="text-sm md:text-base text-white/60 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8 space-y-2">
              <p>
                51影视网汇聚海量免费影视资源，覆盖电影、电视剧、综艺、动漫等全品类内容。每日同步更新热门剧集，高清画质搭配智能加速技术，确保不缓冲流畅播放体验。无论是最新大片还是经典老片，随时随地免费看全集。
              </p>
              <p>
                本周热播：《长安十二时辰》《漫长的季节》《狂飙》《三体》等高口碑国产剧持续更新中，更有院线新片第一时间上线。
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-6 justify-center lg:justify-start mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-movie-line text-primary-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-lg font-bold text-white">10万+</p>
                  <p className="text-xs text-white/50">影视资源</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-speed-up-line text-accent-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-lg font-bold text-white">0缓冲</p>
                  <p className="text-xs text-white/50">智能加速</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-secondary-500/20 flex items-center justify-center">
                  <i className="ri-group-line text-secondary-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-lg font-bold text-white">500万+</p>
                  <p className="text-xs text-white/50">活跃用户</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer no-underline text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-8 py-3.5 border border-white/30 hover:border-white/60 text-white font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer no-underline text-sm"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:block">
            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20floating%20film%20strips%20and%20golden%20spotlight%20effects%2C%20dramatic%20movie%20poster%20composition%20with%20film%20reels%20and%20camera%20lens%20elements%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20luxurious%20cinema%20aesthetic%20with%20velvet%20texture%2C%20professional%20movie%20production%20theme%2C%20rich%20dark%20background%20with%20golden%20accents%2C%20elegant%20film%20noir%20inspired%20visual%20style&width=800&height=600&seq=hero-visual-51movie&orientation=landscape"
                  alt="51影视 - 海量影视资源"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 rounded-2xl overflow-hidden border-4 border-background-50 hidden xl:block">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20streaming%20interface%20with%20movie%20thumbnails%20and%20play%20button%2C%20dark%20theme%20UI%20design%2C%20clean%20minimal%20layout%20with%20film%20poster%20grid%2C%20warm%20accent%20colors%20on%20dark%20background%2C%20professional%20app%20interface%20mockup%2C%20high%20quality%20UI%20design&width=300&height=300&seq=hero-thumb-51movie&orientation=squarish"
                  alt="高清流畅播放"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}